import axios from "axios"
import { image } from "components/shared/SharedInterfaces"
import { SetStateAction } from "react"
import { HOST } from "./constants";

export const getActiveImagesList = (
    setImageData: (value: SetStateAction<image[]>) => void,
    id: number
) => {
    return axios
        .get(`${HOST}/catalogmx/index.php/image/features?id=${id}`)
        .then((response) => {
            if (Array.isArray(response.data)) {
                setImageData(response.data);
            } else {
                console.warn("Respuesta inválida de imágenes:", response.data);
                setImageData([]); // fallback
            }
        })
        .catch((error) => {
            console.error("Error al obtener imágenes:", error);
            setImageData([]);
        });
};

export const getAllImagesList = (
    setImageData: (value: SetStateAction<image[]>) => void,
    id: string
) => {
    return axios
        .get(`${HOST}/catalogmx/index.php/image/features?id=${id}&all=true`)
        .then((response) => {
            if (Array.isArray(response.data)) {
                setImageData(response.data);
            } else {
                console.warn("Respuesta inválida de todas las imágenes:", response.data);
                setImageData([]);
            }
        })
        .catch((error) => {
            console.error("Error al obtener todas las imágenes:", error);
            setImageData([]);
        });
};


export const updImagesActive = async (id: any, active: number) => {

    return axios({
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        url: HOST + '/catalogmx/index.php/image/features',
        data: { id: id, status: active === 1 ? 0 : 1 },
    }).then((responsex: any) => {
        console.info(responsex);
    }).catch(error => { console.error(error) });

}

export const saveImages = async (
    articleId: number,
    fileName: string,
    fileContent: any
) => { 
    return await axios({
        method: 'put',
        headers: { 'Content-Type': 'application/json' },
        url: HOST + '/catalogmx/index.php/image/features',
        data: {
            articleId,
            fileName,
            fileContent
        },
    }).then((response) => response)
        .then(data => data)
        .catch(error => { console.error(error) });
}
